import { Box, MenuItem, Select, Typography } from "@mui/material";
import { USER_ROLES, USER_ROLES_DOMAINS } from "../../../utils/constants/users/userRoles";
import React from "react";
import { useDispatch } from "react-redux";
import { setAlertDialog } from "../../../toolkit/alertDialog/alertDialogSlice";
import theme from "../../../theme";
import { useNavigate } from "react-router-dom";
import { routes } from "src/utils/constants/routes";

const LogInAs = ({
  handleClose
}) => {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  // useState variables start...
  const [signinUserRole, setSigninUserRole] = React.useState("");
  // useState variables end...
  
  // useEffect start...
  React.useEffect(() => {

    console.log(signinUserRole, "signinUserRole")

    if (!signinUserRole) {
      return;
    }

    if (signinUserRole !== USER_ROLES.seller) {
      dispatch(
        setAlertDialog({
          open: true,
          title: `Alert!`,
          message: `Are you sure you want to sign in as ${signinUserRole}?`,
          onOk: () => {
            window.location = USER_ROLES_DOMAINS[signinUserRole]
          }
        })
      )
    } else {
      navigate(routes.authSignin);
      if (handleClose) {
        handleClose();
      }
    }
  }, [signinUserRole]);
  // useEffect end...

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0.5rem",
        padding: "5rem",
        borderRadius: "2rem",
        background: theme.palette.background.paper
      }}
    >
      <Typography
        textAlign="center"
        marginTop={2}
        sx={{
          color: theme.palette.text.primary,
        }}
      >
        Log in as:{" "}
      </Typography>
      <Select
        value={signinUserRole}
        onChange={(e) => {
          setSigninUserRole(e.target.value);
        }}
        // onBlur={formik?.handleBlur}
        displayEmpty
        sx={{
          width: "100%",
          minWidth: "10rem",
          maxWidth: "15rem",
          height: 40,
          "& .MuiSelect-select": {
            opacity: !signinUserRole ? "0.5" : "1"
          },
        }}
      >
        <MenuItem
          value={""}
          disabled
          sx={{
            display: "none",
          }}
        >
          {"Select role"}
        </MenuItem>
        <MenuItem key={USER_ROLES.seller} value={USER_ROLES.seller}>
          {USER_ROLES.seller}
        </MenuItem>
        <MenuItem key={USER_ROLES.dealer} value={USER_ROLES.dealer}>
          {USER_ROLES.dealer}
        </MenuItem>
      </Select>
    </Box>
  );
};

export default LogInAs;